import { baseApi } from '@/api/baseApi';
import type { ListAuditLogFilters, ListAuditLogResponse } from '@/lib/auditLogSchemas';
import { ListAuditLogResponseSchema } from '@/lib/auditLogSchemas';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoint для admin-backend /audit-log.
 * admin-backend на порту 5002 без префикса /admin.
 */
export const auditLogApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listAuditLog: build.query<ListAuditLogResponse, ListAuditLogFilters | void>({
            query: (params) => {
                const search: Record<string, string> = {};
                if (params?.adminId) {
                    search.adminId = params.adminId;
                }
                if (params?.action !== undefined && params.action !== '') {
                    search.action = params.action;
                }
                if (params?.targetType !== undefined && params.targetType !== '') {
                    search.targetType = params.targetType;
                }
                if (params?.dateFrom !== undefined && params.dateFrom !== '') {
                    search.dateFrom = params.dateFrom;
                }
                if (params?.dateTo !== undefined && params.dateTo !== '') {
                    search.dateTo = params.dateTo;
                }
                if (params?.limit !== undefined) {
                    search.limit = String(params.limit);
                }
                if (params?.offset !== undefined) {
                    search.offset = String(params.offset);
                }
                return {
                    url: '/audit-log',
                    method: 'GET',
                    params: search
                };
            },
            transformResponse: (raw: unknown): ListAuditLogResponse =>
                parseWithSchema(ListAuditLogResponseSchema, raw),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((item) => ({
                            type: 'AuditLog' as const,
                            id: item.id
                        })),
                        { type: 'AuditLog' as const, id: 'LIST' }
                    ]
                    : [{ type: 'AuditLog' as const, id: 'LIST' }]
        })
    })
});

export const { useListAuditLogQuery } = auditLogApi;
